// extracted by mini-css-extract-plugin
module.exports = {"createButton":"createButton[Frida]3bZWkrTC"};